/**
 * Common validation utilities
 */

/**
 * Check email format
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if valid email format
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Check postal code format (999-9999)
 * @param {string} postalCode - Postal code to validate
 * @returns {boolean} - True if valid postal code format
 */
export const isValidPostalCode = (postalCode) => {
  const postalCodeRegex = /^\d{3}-\d{4}$/;
  return postalCodeRegex.test(postalCode);
};

/**
 * Check phone number format
 * - Allows digits and hyphens (-)
 * - Cannot start or end with hyphen
 * - Can optionally start with +
 * @param {string} phoneNumber - Phone number to validate
 * @returns {boolean} - True if valid phone number format
 */
export const isValidPhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\+?\d+(-\d+)*$/;
  return phoneRegex.test(phoneNumber);
};
